var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "partner-business-wrapper" },
    [
      _vm.isMobile
        ? _c("TopProgressBar", {
            attrs: {
              isBackShown: !_vm.isMultiBusinessFlow,
              prevStep: "partner-personal-details"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "main-layout partner-business-view",
          class: _vm.viewClass
        },
        [
          _c("h1", { staticClass: "page-title" }, [
            _vm._v(
              _vm._s(
                _vm.isMultiBusinessFlow
                  ? "Lets get started"
                  : "Your business details"
              )
            )
          ]),
          _vm._v(" "),
          _vm.isMultiBusinessFlow
            ? _c("h1", { staticClass: "multi-business-subtitle" }, [
                _vm._v(
                  "You're about to create a new business account under your existing Lili profile, using your current personal details."
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              staticClass: "-helper--flex column fluid",
              attrs: { id: "v-form" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.handleSubmit.apply(null, arguments)
                }
              }
            },
            [
              _vm._v(
                "\n\n    " + _vm._s(/** Section Business Type */) + "\n    "
              ),
              _c(
                "div",
                {
                  ref: "businessTypeSection",
                  staticClass: "business-data-section"
                },
                [
                  _c("h1", { staticClass: "section-title" }, [
                    _vm._v("Business type")
                  ]),
                  _vm._v(" "),
                  _c("BusinessTypeForm")
                ],
                1
              ),
              _vm._v(
                "\n    " + _vm._s(/** Section Business Details */) + "\n    "
              ),
              _vm.customerData.incomeType.enum
                ? _c(
                    "div",
                    {
                      ref: "businessDetailsSection",
                      staticClass: "business-data-section relative"
                    },
                    [
                      _c("h1", { staticClass: "section-title" }, [
                        _vm._v("Business details")
                      ]),
                      _vm._v(" "),
                      _c("h1", { staticClass: "section-sub-title" }, [
                        _vm._v(
                          "Please select the industry that best describes your business"
                        )
                      ]),
                      _vm._v(" "),
                      _c("BusinessDetailsForm")
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(
                "\n    " + _vm._s(/** Section Business Address */) + "\n    "
              ),
              _vm.customerData.incomeType.enum && !_vm.shouldHideAddressSection
                ? _c(
                    "div",
                    {
                      ref: "businessAddressSection",
                      staticClass: "business-data-section relative"
                    },
                    [
                      _c("h1", { staticClass: "section-title" }, [
                        _vm._v("Business address")
                      ]),
                      _vm._v(" "),
                      _c("h1", { staticClass: "section-sub-title" }, [
                        _vm._v(
                          "Please provide your primary business address (not your registered agent address)."
                        )
                      ]),
                      _vm._v(" "),
                      _c("BusinessAddressForm")
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(
                "\n    " + _vm._s(/** Section Business Owners */) + "\n    "
              ),
              _vm.customerData.incomeType.enum && !_vm.shouldHideOwnersSection
                ? _c(
                    "div",
                    {
                      ref: "businessOwnersSection",
                      staticClass: "business-data-section relative"
                    },
                    [
                      _c("h1", { staticClass: "section-title" }, [
                        _vm._v("Business owners")
                      ]),
                      _vm._v(" "),
                      _c("h1", { staticClass: "section-sub-title" }, [
                        _vm._v(
                          "Please specify your ownership in the business, and provide all ultimate beneficial owners (UBOs) that hold 25% or more of the business."
                        )
                      ]),
                      _vm._v(" "),
                      _c("BusinessOwners")
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v("\n    " + _vm._s(/** Footer */) + "\n    "),
              _c("ActionFooter", {
                attrs: {
                  errMsg: _vm.localError.ownerPercent,
                  "is-loading": _vm.flags.isLoading
                },
                on: { onsubmit: _vm.handleSubmit }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isMobile ? _c("MobileFooter", { staticClass: "full" }) : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eb62ea9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb62ea9c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PartnerOnboarding/PartnerBusiness.vue
// module id = null
// module chunks = 